import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MenuHeaderBackgroundAssetComponent } from '../../menu-header-background-asset/menu-header-background-asset.component';

@Component({
  selector: 'app-menu-header-plantlife-cheap-weed',
  templateUrl: './menu-header-plantlife-cheap-weed.component.html',
  providers: [{ provide: MenuHeaderBackgroundAssetComponent, useExisting: MenuHeaderPlantlifeCheapWeedComponent }],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MenuHeaderPlantlifeCheapWeedComponent extends MenuHeaderBackgroundAssetComponent {}
